import React from 'react';
import { Tag } from 'antd';
import type { TaskHistoryCategory } from '../../types/taskHistory';
import { TASK_CATEGORY_COLORS } from './taskHistoryCategoryColors';

export interface TaskCategoryBadgeProps {
  category: TaskHistoryCategory | string;
  label?: string | null;
}

const TaskCategoryBadge: React.FC<TaskCategoryBadgeProps> = ({ category, label }) => {
  const key = String(category || 'OTHER').toUpperCase() as TaskHistoryCategory;
  const color = TASK_CATEGORY_COLORS[key] ?? TASK_CATEGORY_COLORS.OTHER;
  const text = label?.trim() || '—';
  return (
    <Tag color={color} style={{ marginInlineEnd: 0 }}>
      {text}
    </Tag>
  );
};

export default TaskCategoryBadge;
